/**
 * Lightbox for every [data-lightbox] group of [data-lightbox-item] links.
 * Native <dialog>: focus trap, Esc, keyboard arrows, swipe, preloading.
 * Without JS the links simply open the large image.
 */
(() => {
	const groups = document.querySelectorAll('[data-lightbox]');
	if (!groups.length || typeof HTMLDialogElement !== 'function') {
		return;
	}

	const t = (window.JD && window.JD.i18n) || {};
	const icon = (d) => `<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true"><path d="${d}"/></svg>`;
	const ICONS = {
		close: icon('M6.4 5 12 10.6 17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19 5 17.6l5.6-5.6L5 6.4Z'),
		prev: icon('M20 11v2H7.8l4.6 4.6-1.4 1.4-7-7 7-7 1.4 1.4L7.8 11Z'),
		next: icon('M4 11v2h12.2l-4.6 4.6 1.4 1.4 7-7-7-7-1.4 1.4 4.6 4.6Z'),
	};

	const dialog = document.createElement('dialog');
	dialog.className = 'lightbox';
	dialog.setAttribute('aria-label', 'Photo');
	dialog.innerHTML = `
		<div class="lightbox__bar">
			<span class="lightbox__count" aria-live="polite"></span>
			<button type="button" class="lightbox__btn lightbox__close" aria-label="${t.close || 'Close'}">${ICONS.close}</button>
		</div>
		<div class="lightbox__stage">
			<img class="lightbox__img" alt="">
			<button type="button" class="lightbox__btn lightbox__prev" aria-label="${t.previous || 'Previous'}">${ICONS.prev}</button>
			<button type="button" class="lightbox__btn lightbox__next" aria-label="${t.next || 'Next'}">${ICONS.next}</button>
		</div>
		<p class="lightbox__caption"></p>`;
	document.body.append(dialog);

	const img = dialog.querySelector('.lightbox__img');
	const count = dialog.querySelector('.lightbox__count');
	const caption = dialog.querySelector('.lightbox__caption');
	const stage = dialog.querySelector('.lightbox__stage');

	let items = [];
	let index = 0;
	let opener = null;

	const preload = (i) => {
		const item = items[(i + items.length) % items.length];
		if (item) {
			new Image().src = item.href;
		}
	};

	const show = (i) => {
		index = (i + items.length) % items.length;
		const link = items[index];
		const thumb = link.querySelector('img');

		img.classList.add('is-loading');
		img.onload = () => img.classList.remove('is-loading');
		img.src = link.href;
		img.alt = thumb ? thumb.alt : '';
		if (link.dataset.width) {
			img.width = link.dataset.width;
			img.height = link.dataset.height;
		}
		count.textContent = items.length > 1 ? `${index + 1} / ${items.length}` : '';
		caption.textContent = link.dataset.caption || img.alt || '';

		preload(index + 1);
		preload(index - 1);
	};

	const open = (group, link) => {
		items = [...group.querySelectorAll('[data-lightbox-item]')];
		opener = link;
		dialog.classList.toggle('lightbox--single', items.length < 2);
		show(items.indexOf(link));
		document.documentElement.classList.add('lightbox-open');
		dialog.showModal();
	};

	dialog.addEventListener('close', () => {
		document.documentElement.classList.remove('lightbox-open');
		img.removeAttribute('src');
		opener?.focus({ preventScroll: true });
	});

	dialog.querySelector('.lightbox__close').addEventListener('click', () => dialog.close());
	dialog.querySelector('.lightbox__prev').addEventListener('click', () => show(index - 1));
	dialog.querySelector('.lightbox__next').addEventListener('click', () => show(index + 1));

	// Click on the dark background closes.
	stage.addEventListener('click', (e) => {
		if (e.target === stage) {
			dialog.close();
		}
	});

	dialog.addEventListener('keydown', (e) => {
		if (e.key === 'ArrowLeft') {
			show(index - 1);
		} else if (e.key === 'ArrowRight') {
			show(index + 1);
		}
	});

	// Swipe
	let startX = null;
	stage.addEventListener('pointerdown', (e) => {
		startX = e.pointerType === 'mouse' ? null : e.clientX;
	});
	stage.addEventListener('pointerup', (e) => {
		if (startX === null) {
			return;
		}
		const dx = e.clientX - startX;
		startX = null;
		if (Math.abs(dx) > 50) {
			show(index + (dx < 0 ? 1 : -1));
		}
	});

	groups.forEach((group) => {
		group.addEventListener('click', (e) => {
			const link = e.target.closest('[data-lightbox-item]');
			if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
				return;
			}
			e.preventDefault();
			open(group, link);
		});
	});
})();
